var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper cyber-wrapper",attrs:{"id":"app"}},[_c('top-menu'),_c('left-menu'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('footer-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }